import Column from '@components/Column';
import Divider from '@components/Divider';
import Row from '@components/Row';
import Text from '@components/Text';
import styled from '@emotion/styled';
import { Fragment } from 'react';

import useShopRecommendedItems from './hooks/useShopRecommendedItems';
import RecommendationItem from './RecommendationItem';

interface Props {
    shopId: string;
    itemId: string;
}

function Recommendation({ shopId, itemId }:Props) {
    const { title, items } = useShopRecommendedItems(shopId, itemId);
    if (items && items.length > 0) {
        return (
            <Fragment>
                <Divider/>
                <Container fullWidth as='section' spacing={4}>
                    {title && (
                        <TitleWrapper>
                            <Text size='title' fontWeight='bold'>{title}</Text>
                        </TitleWrapper>
                    )}
                    <Contents as='article' spacing={4} align='flex-start'>
                        {items?.map((item) => (
                            <RecommendationItem item={item}
                                shopId={shopId}
                                key={item.shopItemId} />
                        ))}
                    </Contents>
                </Container>
            </Fragment>
        );
    }
    return null;
}

const Container = styled(Column)`
    padding: var(--spacing-4) 0;
`;

const TitleWrapper = styled.div`
    padding: 0 var(--spacing-5);
`;

const Contents = styled(Row)`
    padding: 0 var(--spacing-5);
    scroll-snap-type: x mandatory;
    scroll-padding: 0 var(--spacing-5);
    max-width: 100%;
    overflow-x: auto;
    &::-webkit-scrollbar {
        display: none;
    }
`;

export default Recommendation;
